angular.module('dnecom')
    .controller('StoreCustomScriptsSettingsController', ["$scope", "StoreUtils", "IntegrationsUtils", "notifications", function ($scope, StoreUtils, IntegrationsUtils, notifications) {
        $scope.accounts = [];

        $scope.isOldFacebookPixelIntegration = function () {
            var value = StoreUtils.getFieldValue($scope.store, 'meta', 'facebookPixelCode');

            if (value != null || (value != null && value.length > 0)) {
                return true;
            }

            return false;
        };

        IntegrationsUtils.getAccountsByTypes(function (accounts) {
            if (!_.isEmpty(accounts) && accounts.facebookpixel) {
                $scope.accounts = accounts.facebookpixel;
            }
        });

        $scope.$watch(function () {
            try {
                return $scope.store.properties.meta.facebookPixelCode;
            } catch(e) {
                return null;
            }
        }, function (newValue, oldValue) {
            if (oldValue != null && oldValue.length > 0) {
                if (newValue == null || (newValue != null && newValue.length <= 0)) {
                    notifications.info("Old facebook pixel integration will be removed. Select new one from a list.");
                }
            }
        });
    }]);
